(function () {
  'use strict';

  /* ==========================================================================
     Configuration
     ========================================================================== */

  var HAT_CONFIG = {
    'Classic Sports Lid': {
      moq: 50,
      colourPanel: 'cof-colours-sports',
      refImage: 'cof-ref-sports',
      sizes: ['YOUTH (50cm)', 'S/XS (55cm)', 'OSFM (58cm)', 'L/XL (61cm)'],
      defaultSize: 'OSFM (58cm)',
      colourFields: [
        { name: 'sports_base_colour', key: 'base_colour', required: true },
        { name: 'sports_lower_side_panel_colour', key: 'lower_side_panel_colour', required: true },
        { name: 'sports_top_side_panel_type', key: 'top_side_panel_type', required: true },
        { name: 'sports_top_side_panel_detail', key: 'top_side_panel_detail', required: true }
      ]
    },
    'Pro Sports Lid': {
      moq: 50,
      colourPanel: 'cof-colours-sports',
      refImage: 'cof-ref-sports',
      sizes: ['YOUTH (50cm)', 'S/XS (55cm)', 'OSFM (58cm)', 'L/XL (61cm)'],
      defaultSize: 'OSFM (58cm)',
      colourFields: [
        { name: 'sports_base_colour', key: 'base_colour', required: true },
        { name: 'sports_lower_side_panel_colour', key: 'lower_side_panel_colour', required: true },
        { name: 'sports_top_side_panel_type', key: 'top_side_panel_type', required: true },
        { name: 'sports_top_side_panel_detail', key: 'top_side_panel_detail', required: true }
      ]
    },
    'Retro Lid': {
      moq: 25,
      colourPanel: 'cof-colours-retro',
      refImage: 'cof-ref-retro',
      sizes: ['OSFM', 'L/XL'],
      defaultSize: 'OSFM',
      colourFields: [
        { name: 'retro_crown_colour', key: 'crown_colour', required: true },
        { name: 'retro_brim_colour', key: 'brim_colour', required: true },
        { name: 'retro_top_button_colour', key: 'top_button_colour', required: false }
      ]
    },
    'Bucket Lid': {
      moq: 50,
      colourPanel: 'cof-colours-bucket',
      refImage: 'cof-ref-bucket',
      sizes: ['S/M (60cm)', 'L/XL (61cm)'],
      defaultSize: 'S/M (60cm)',
      colourFields: [
        { name: 'bucket_base_colour', key: 'base_colour', required: true },
        { name: 'bucket_underneath_brim_colour', key: 'underneath_brim_colour', required: true },
        { name: 'bucket_lower_side_mesh_colour', key: 'lower_side_mesh_colour', required: true },
        { name: 'bucket_main_side_panel_type', key: 'main_side_panel_type', required: true },
        { name: 'bucket_main_side_panel_detail', key: 'main_side_panel_detail', required: true }
      ]
    },
    'OG Lid': {
      moq: 25,
      colourPanel: 'cof-colours-og',
      refImage: 'cof-ref-og',
      sizes: ['S/XS (55cm)', 'OSFM (58cm)', 'L/XL (60cm)'],
      defaultSize: 'OSFM (58cm)',
      colourFields: [
        { name: 'og_crown_colour', key: 'crown_colour', required: true },
        { name: 'og_brim_colour', key: 'brim_colour', required: true },
        { name: 'og_top_button_colour', key: 'top_button_colour', required: false }
      ]
    }
  };

  var STORAGE_KEY = 'cof_form_data';
  var MAX_FILE_SIZE = 5 * 1024 * 1024;
  var ACCEPTED_EXT = ['.png', '.jpg', '.jpeg', '.svg', '.pdf'];
  var MAX_SIZE_ROWS = 8;

  /* ==========================================================================
     DOM refs
     ========================================================================== */

  var form, hatTypeSelect, coloursSection, moqMsg, sizeRowsContainer,
      addSizeBtn, addSizeWrap, qtyTracker, qtyText, submitBtn, submitText,
      submitLoader, successEl, errorEl, errorMsg, sizesWrap;

  /* ==========================================================================
     State
     ========================================================================== */

  var currentHat = null;
  var currentHatType = '';
  var sizeRowCount = 0;
  var fileData = {
    front_logo: null, back_logo: null, side_logo: null,
    sports_pattern: null, bucket_pattern: null
  };

  /* ==========================================================================
     Init
     ========================================================================== */

  function init() {
    form = document.getElementById('custom-order-form');
    if (!form) return;

    hatTypeSelect = document.getElementById('cof-hat-type');
    coloursSection = document.getElementById('cof-colours-section');
    moqMsg = document.getElementById('cof-moq-msg');
    sizeRowsContainer = document.getElementById('cof-size-rows');
    addSizeBtn = document.getElementById('cof-add-size');
    addSizeWrap = document.getElementById('cof-add-size-wrap');
    qtyTracker = document.getElementById('cof-qty-tracker');
    qtyText = document.getElementById('cof-qty-text');
    submitBtn = document.getElementById('cof-submit-btn');
    submitText = submitBtn.querySelector('.cof-submit-text');
    submitLoader = submitBtn.querySelector('.cof-submit-loader');
    successEl = document.getElementById('cof-success');
    errorEl = document.getElementById('cof-error');
    errorMsg = document.getElementById('cof-error-msg');
    sizesWrap = document.getElementById('cof-sizes-wrap');

    // Event listeners
    hatTypeSelect.addEventListener('change', onHatTypeChange);
    addSizeBtn.addEventListener('click', addSizeRow);
    form.addEventListener('submit', onSubmit);
    form.addEventListener('input', debounce(saveToStorage, 300));
    form.addEventListener('change', saveToStorage);

    // Pattern toggle listeners
    document.querySelectorAll('[data-pattern-toggle]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        onPatternToggle(sel);
      });
    });

    // Visual hat picker — wires radio cards to the hidden select
    initHatPicker();

    // File upload setup
    initFileUploads();

    // Restore from localStorage
    restoreFromStorage();
  }

  /* ==========================================================================
     Visual hat picker — radio cards drive the hidden select
     ========================================================================== */

  function initHatPicker() {
    var cards = document.querySelectorAll('.cof-hat-card');
    if (!cards.length) return;

    // Mark the form as card-mode so the fallback select hides via CSS,
    // and drop `required` from the now-hidden select (the cards drive it).
    form.classList.add('is-card-mode');
    if (hatTypeSelect) {
      hatTypeSelect.removeAttribute('required');
      hatTypeSelect.setAttribute('tabindex', '-1');
      hatTypeSelect.setAttribute('aria-hidden', 'true');
    }

    cards.forEach(function (card) {
      var radio = card.querySelector('.cof-hat-card__radio');
      if (!radio) return;

      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        if (hatTypeSelect.value !== radio.value) {
          hatTypeSelect.value = radio.value;
          hatTypeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // Hide the sizes empty-state once a hat is chosen
        var emptyEl = document.getElementById('cof-sizes-empty');
        if (emptyEl) emptyEl.style.display = 'none';
      });
    });
  }

  function syncHatPickerToValue(value) {
    var cards = document.querySelectorAll('.cof-hat-card');
    cards.forEach(function (card) {
      var radio = card.querySelector('.cof-hat-card__radio');
      var match = radio && radio.value === value;
      card.classList.toggle('is-selected', !!match);
      if (radio) radio.checked = !!match;
    });
    if (value) {
      var emptyEl = document.getElementById('cof-sizes-empty');
      if (emptyEl) emptyEl.style.display = 'none';
    }
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  /* ==========================================================================
     Hat type change
     ========================================================================== */

  function onHatTypeChange() {
    var hatType = hatTypeSelect.value;
    if (!hatType || !HAT_CONFIG[hatType]) return;

    currentHat = HAT_CONFIG[hatType];
    currentHatType = hatType;

    // Keep visual picker in sync (e.g. when restored from storage)
    syncHatPickerToValue(hatType);

    // Show colours section
    coloursSection.style.display = '';

    // Hide all colour panels
    document.querySelectorAll('.cof-hat-colours').forEach(function (el) {
      el.style.display = 'none';
    });

    // Show the correct one
    var panel = document.getElementById(currentHat.colourPanel);
    if (panel) panel.style.display = '';

    // Hide all reference images, show correct one
    document.querySelectorAll('.cof-ref-img').forEach(function (el) {
      el.style.display = 'none';
    });
    var refImg = document.getElementById(currentHat.refImage);
    if (refImg) refImg.style.display = '';

    // MOQ message
    moqMsg.style.display = '';
    moqMsg.textContent = 'Minimum order: ' + currentHat.moq + ' units for ' + hatType;

    // Show sizes section and rebuild rows
    sizesWrap.style.display = '';
    rebuildSizeRows();

    // Update qty tracker
    updateQtyTracker();
    saveToStorage();
  }

  /* ==========================================================================
     Pattern toggle (show/hide pattern upload when Pattern is selected)
     ========================================================================== */

  function onPatternToggle(sel) {
    var group = sel.getAttribute('data-pattern-toggle');
    var patternUpload = document.getElementById('cof-pattern-upload-' + group);
    var hint = document.querySelector('[data-hint-for="' + group + '"]');

    if (!patternUpload) return;

    if (sel.value === 'Pattern') {
      patternUpload.style.display = '';
      if (hint) hint.textContent = 'Describe the pattern you want';
    } else {
      patternUpload.style.display = 'none';
      if (hint) hint.textContent = 'Enter the colour';
    }
  }

  /* ==========================================================================
     Size rows — all hat types use the same add-row system
     ========================================================================== */

  function rebuildSizeRows() {
    // Clear existing rows
    sizeRowsContainer.innerHTML = '';
    sizeRowCount = 0;

    // Add one default row with the hat's default size pre-selected
    addSizeRow(currentHat.defaultSize);

    // Show add button
    if (sizeRowCount < MAX_SIZE_ROWS) {
      addSizeBtn.style.display = '';
    }
  }

  function updateSizeOptions() {
    if (!currentHat) return;
    var selects = sizeRowsContainer.querySelectorAll('[data-size-select]');
    selects.forEach(function (sel) {
      var currentVal = sel.value;
      sel.innerHTML = '<option value="" disabled selected></option>';
      currentHat.sizes.forEach(function (size) {
        var opt = document.createElement('option');
        opt.value = size;
        opt.textContent = size;
        sel.appendChild(opt);
      });
      if (currentHat.sizes.indexOf(currentVal) !== -1) {
        sel.value = currentVal;
      }
    });
  }

  function addSizeRow(preselect) {
    if (sizeRowCount >= MAX_SIZE_ROWS) return;

    var idx = sizeRowCount;
    var row = document.createElement('div');
    row.className = 'cof-size-row';
    row.setAttribute('data-row-index', idx);

    var sizeOpts = '';
    if (currentHat) {
      currentHat.sizes.forEach(function (s) {
        var selected = (preselect && s === preselect) ? ' selected' : '';
        sizeOpts += '<option value="' + s + '"' + selected + '>' + s + '</option>';
      });
    }

    var showRemove = sizeRowCount > 0;

    row.innerHTML =
      '<div class="cof-size-row__fields">' +
        '<div class="form-control cof-size-row__size">' +
          '<select class="select select--native is-floating" name="size_' + idx + '" data-size-select required>' +
            '<option value="" disabled' + (preselect ? '' : ' selected') + '></option>' +
            sizeOpts +
          '</select>' +
          '<svg class="select-chevron" width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 6L0.5 1.5h6L3.5 6z" fill="currentColor"/></svg>' +
          '<label class="floating-label">Size *</label>' +
        '</div>' +
        '<div class="form-control cof-size-row__qty">' +
          '<input class="input is-floating" type="number" name="qty_' + idx + '" min="1" placeholder=" " data-qty-input required>' +
          '<label class="floating-label">Quantity *</label>' +
        '</div>' +
        (showRemove ? '<button type="button" class="cof-size-row__remove" aria-label="Remove size row">&times;</button>' : '<div class="cof-size-row__spacer"></div>') +
      '</div>';

    if (showRemove) {
      row.querySelector('.cof-size-row__remove').addEventListener('click', function () {
        removeRow(row);
      });
    }

    row.querySelector('[data-qty-input]').addEventListener('input', function () {
      updateQtyTracker();
    });

    sizeRowsContainer.appendChild(row);
    sizeRowCount++;

    if (sizeRowCount >= MAX_SIZE_ROWS) {
      addSizeBtn.style.display = 'none';
    }

    updateQtyTracker();
  }

  function removeRow(row) {
    row.remove();
    // Re-index remaining rows
    var rows = sizeRowsContainer.querySelectorAll('.cof-size-row');
    rows.forEach(function (r, i) {
      r.setAttribute('data-row-index', i);
      var sel = r.querySelector('[data-size-select]');
      if (sel) sel.name = 'size_' + i;
      var qty = r.querySelector('[data-qty-input]');
      if (qty) qty.name = 'qty_' + i;
    });
    sizeRowCount = rows.length;

    if (sizeRowCount < MAX_SIZE_ROWS) {
      addSizeBtn.style.display = '';
    }

    updateQtyTracker();
    saveToStorage();
  }

  function getTotalQty() {
    if (!currentHat) return 0;

    var total = 0;
    sizeRowsContainer.querySelectorAll('[data-qty-input]').forEach(function (inp) {
      var v = parseInt(inp.value, 10);
      if (!isNaN(v) && v > 0) total += v;
    });
    return total;
  }

  function updateQtyTracker() {
    if (!currentHat) {
      qtyTracker.style.display = 'none';
      return;
    }

    var total = getTotalQty();
    var moq = currentHat.moq;

    qtyTracker.style.display = '';
    qtyTracker.classList.remove('is-met', 'is-under');

    if (total >= moq) {
      qtyTracker.classList.add('is-met');
      qtyText.innerHTML = '<span class="cof-qty-check"></span>Total units: ' + total + ' / Minimum: ' + moq;
    } else {
      qtyTracker.classList.add('is-under');
      qtyText.innerHTML = '<span class="cof-qty-warn"></span>Total units: ' + total + ' / Minimum: ' + moq;
    }
  }

  /* ==========================================================================
     File uploads
     ========================================================================== */

  function initFileUploads() {
    document.querySelectorAll('.cof-upload__area').forEach(function (area) {
      var key = area.getAttribute('data-upload');
      if (!key) return;
      var input = area.querySelector('.cof-upload__input');
      var content = area.querySelector('.cof-upload__content');
      var preview = area.querySelector('.cof-upload__preview');
      var filenameEl = area.querySelector('.cof-upload__filename');
      var removeBtn = area.querySelector('.cof-upload__remove');

      area.addEventListener('dragover', function (e) {
        e.preventDefault();
        area.classList.add('is-dragover');
      });

      area.addEventListener('dragleave', function () {
        area.classList.remove('is-dragover');
      });

      area.addEventListener('drop', function (e) {
        e.preventDefault();
        area.classList.remove('is-dragover');
        if (e.dataTransfer.files.length > 0) {
          processFile(e.dataTransfer.files[0], key, area, content, preview, filenameEl, input);
        }
      });

      input.addEventListener('change', function () {
        if (input.files.length > 0) {
          processFile(input.files[0], key, area, content, preview, filenameEl, input);
        }
      });

      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        fileData[key] = null;
        input.value = '';
        area.classList.remove('has-file', 'has-error');
        content.style.display = '';
        preview.style.display = 'none';
        saveToStorage();
      });
    });
  }

  function processFile(file, key, area, content, preview, filenameEl, input) {
    area.classList.remove('has-error');

    if (file.size > MAX_FILE_SIZE) {
      showFieldError(area, 'File too large. Maximum 10MB.');
      return;
    }

    var ext = '.' + file.name.split('.').pop().toLowerCase();
    if (ACCEPTED_EXT.indexOf(ext) === -1) {
      showFieldError(area, 'Invalid file type. Use PNG, JPG, SVG, or PDF.');
      return;
    }

    fileData[key] = {
      filename: file.name,
      file: file,
      size: file.size,
      type: file.type
    };

    area.classList.add('has-file');
    content.style.display = 'none';
    preview.style.display = '';
    filenameEl.textContent = file.name;
    saveToStorage();
  }

  function showFieldError(el, msg) {
    el.classList.add('has-error');
    var existing = el.parentElement.querySelector('.cof-field-error');
    if (existing) existing.remove();

    var span = document.createElement('span');
    span.className = 'cof-field-error';
    span.textContent = msg;
    el.parentElement.appendChild(span);

    setTimeout(function () {
      el.classList.remove('has-error');
      if (span.parentElement) span.remove();
    }, 5000);
  }

  /* ==========================================================================
     Validation
     ========================================================================== */

  function clearValidation() {
    form.querySelectorAll('.cof-invalid').forEach(function (el) {
      el.classList.remove('cof-invalid');
    });
    form.querySelectorAll('.cof-field-error').forEach(function (el) {
      el.remove();
    });
    errorEl.style.display = 'none';
  }

  function validateForm() {
    clearValidation();
    var errors = [];
    var firstInvalid = null;

    function markInvalid(el, msg) {
      el.classList.add('cof-invalid');
      if (!firstInvalid) firstInvalid = el;
      var span = document.createElement('span');
      span.className = 'cof-field-error';
      span.textContent = msg;
      var parent = el.closest('.form-control') || el.closest('.cof-upload-card');
      if (parent) parent.appendChild(span);
    }

    // Section 1 — Contact
    var nameField = form.querySelector('[name="name"]');
    var email = form.querySelector('[name="email"]');

    if (!nameField.value.trim()) {
      markInvalid(nameField, 'Full name is required');
      errors.push('Name required');
    }

    if (!email.value.trim()) {
      markInvalid(email, 'Email is required');
      errors.push('Email required');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      markInvalid(email, 'Enter a valid email address');
      errors.push('Invalid email');
    }

    // Section 2 — Hat type
    if (!hatTypeSelect.value) {
      markInvalid(hatTypeSelect, 'Select a hat type');
      errors.push('Hat type required');
    }

    // Section 3 — Colour fields (only validate visible panel)
    if (currentHat) {
      var panel = document.getElementById(currentHat.colourPanel);
      if (panel) {
        currentHat.colourFields.forEach(function (field) {
          if (!field.required) return;
          var el = panel.querySelector('[name="' + field.name + '"]');
          if (el && !el.value.trim()) {
            markInvalid(el, 'This field is required');
            errors.push(field.key + ' required');
          }
        });
      }
    }

    // Section 4 — Front logo required
    if (!fileData.front_logo) {
      var frontArea = document.querySelector('[data-upload="front_logo"]');
      if (frontArea) {
        frontArea.classList.add('has-error');
        if (!firstInvalid) firstInvalid = frontArea;
        var span = document.createElement('span');
        span.className = 'cof-field-error';
        span.textContent = 'Front logo is required';
        frontArea.closest('.cof-upload-card').appendChild(span);
      }
      errors.push('Front logo required');
    }

    // Front decoration method required
    var frontDeco = form.querySelector('[name="front_logo_decoration"]');
    if (frontDeco && !frontDeco.value) {
      markInvalid(frontDeco, 'Select a decoration method');
      errors.push('Front logo decoration required');
    }

    // Section 5 — Sizes
    if (currentHat) {
      sizeRowsContainer.querySelectorAll('[data-size-select]').forEach(function (sel) {
        if (!sel.value) {
          markInvalid(sel, 'Select a size');
          errors.push('Size required');
        }
      });
      sizeRowsContainer.querySelectorAll('[data-qty-input]').forEach(function (inp) {
        var v = parseInt(inp.value, 10);
        if (isNaN(v) || v < 1) {
          markInvalid(inp, 'Enter a quantity');
          errors.push('Quantity required');
        }
      });

      // MOQ check
      var total = getTotalQty();
      if (total < currentHat.moq) {
        errors.push('Total quantity (' + total + ') is below the minimum order of ' + currentHat.moq + ' units');
      }
    }

    if (errors.length > 0 && firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return errors;
  }

  /* ==========================================================================
     File upload to R2
     ========================================================================== */

  function uploadFileToR2(fileObj, uploadUrl) {
    if (!fileObj || !fileObj.file) return Promise.resolve(null);

    var fd = new FormData();
    fd.append('file', fileObj.file, fileObj.filename);

    return fetch(uploadUrl, { method: 'POST', body: fd, headers: { 'X-LL-Webhook-Auth': 'hCevhVRRG852uPIi-hm7SJfQD-elWYCMF_8JNm2YYUs' } })
      .then(function (resp) {
        if (!resp.ok) throw new Error('Upload failed for ' + fileObj.filename);
        return resp.json();
      })
      .then(function (result) {
        return result.success ? result.url : null;
      })
      .catch(function (err) {
        console.error('File upload error:', err);
        return null;
      });
  }

  /* ==========================================================================
     Build colour spec string from dynamic colour fields
     ========================================================================== */

  function buildColourSpecString(hatType) {
    var config = HAT_CONFIG[hatType];
    if (!config) return '';

    var panel = document.getElementById(config.colourPanel);
    if (!panel) return '';

    var parts = [];
    config.colourFields.forEach(function (field) {
      var el = panel.querySelector('[name="' + field.name + '"]');
      if (el && el.value.trim()) {
        // Format key: base_colour → Base Colour
        var label = field.key.replace(/_/g, ' ').replace(/\b\w/g, function (l) { return l.toUpperCase(); });
        parts.push(label + ': ' + el.value.trim());
      }
    });

    return parts.join(', ');
  }

  /* ==========================================================================
     Build panel details string
     ========================================================================== */

  function buildPanelDetailsString(hatType) {
    var config = HAT_CONFIG[hatType];
    if (!config) return null;

    var panel = document.getElementById(config.colourPanel);
    if (!panel) return null;

    // Sports lids: top side panel
    if (hatType === 'Classic Sports Lid' || hatType === 'Pro Sports Lid') {
      var sType = panel.querySelector('[name="sports_top_side_panel_type"]');
      var sDetail = panel.querySelector('[name="sports_top_side_panel_detail"]');
      if (sType && sType.value && sDetail && sDetail.value) {
        return sType.value + ' — ' + sDetail.value.trim();
      }
    }

    // Bucket lid: main side panel
    if (hatType === 'Bucket Lid') {
      var bType = panel.querySelector('[name="bucket_main_side_panel_type"]');
      var bDetail = panel.querySelector('[name="bucket_main_side_panel_detail"]');
      if (bType && bType.value && bDetail && bDetail.value) {
        return bType.value + ' — ' + bDetail.value.trim();
      }
    }

    return null;
  }

  /* ==========================================================================
     Form submission — uploads files to R2, then sends JSON to webhook
     ========================================================================== */

  var _formSubmitting = false;

  function onSubmit(e) {
    e.preventDefault();

    if (_formSubmitting) return;

    // Honeypot check — bots fill hidden fields, humans don't
    var honeypot = document.getElementById('cof-website');
    if (honeypot && honeypot.value) return;

    var errors = validateForm();
    if (errors.length > 0) {
      errorEl.style.display = '';
      errorMsg.textContent = errors[0];
      return;
    }

    var webhookEl = document.getElementById('cof-webhook-url');
    if (!webhookEl) {
      errorEl.style.display = '';
      errorMsg.textContent = 'Form submission is not configured. Please contact the site administrator.';
      return;
    }
    var baseUrl = webhookEl.value;
    if (!baseUrl) {
      errorEl.style.display = '';
      errorMsg.textContent = 'Form submission is not configured. Please contact the site administrator.';
      return;
    }

    // Normalise base URL — strip any trailing slashes or /submit suffix
    var basePath = baseUrl.replace(/\/+$/, '').replace(/\/submit$/, '');
    var submitUrl = basePath + '/submit';
    var uploadUrl = basePath + '/upload';

    _formSubmitting = true;
    submitBtn.disabled = true;
    submitText.style.display = 'none';
    submitLoader.style.display = '';
    errorEl.style.display = 'none';

    // Determine which pattern file (if any) to upload
    var patternKey = null;
    if (currentHat && currentHat.colourPanel === 'cof-colours-sports') patternKey = 'sports_pattern';
    if (currentHat && currentHat.colourPanel === 'cof-colours-bucket') patternKey = 'bucket_pattern';

    // Upload all files to R2 in parallel, then submit
    Promise.all([
      uploadFileToR2(fileData.front_logo, uploadUrl),
      uploadFileToR2(fileData.back_logo, uploadUrl),
      uploadFileToR2(fileData.side_logo, uploadUrl),
      patternKey ? uploadFileToR2(fileData[patternKey], uploadUrl) : Promise.resolve(null)
    ])
    .then(function (urls) {
      var frontLogoUrl = urls[0];
      var backLogoUrl = urls[1];
      var sideLogoUrl = urls[2];
      var patternFileUrl = urls[3];

      // Verify critical file uploads succeeded — if a file was provided but
      // upload returned null, the artwork would be missing from the order.
      var uploadErrors = [];
      if (fileData.front_logo && fileData.front_logo.file && !frontLogoUrl) uploadErrors.push('front logo');
      if (fileData.back_logo && fileData.back_logo.file && !backLogoUrl) uploadErrors.push('back logo');
      if (fileData.side_logo && fileData.side_logo.file && !sideLogoUrl) uploadErrors.push('side logo');
      if (patternKey && fileData[patternKey] && fileData[patternKey].file && !patternFileUrl) uploadErrors.push('pattern file');
      if (uploadErrors.length > 0) {
        throw new Error('Upload failed for: ' + uploadErrors.join(', ') + '. Please try again.');
      }

      // Build colour spec and panel details
      var hatType = hatTypeSelect.value;
      var colourSpec = buildColourSpecString(hatType);
      var panelDetails = buildPanelDetailsString(hatType);

      // Collect sizes
      var sizes = [];
      sizeRowsContainer.querySelectorAll('.cof-size-row').forEach(function (row) {
        var sel = row.querySelector('[data-size-select]');
        var qty = row.querySelector('[data-qty-input]');
        if (sel && qty && sel.value && parseInt(qty.value, 10) > 0) {
          sizes.push({ size: sel.value, quantity: parseInt(qty.value, 10) });
        }
      });

      // Get per-logo decoration methods
      var frontDeco = form.querySelector('[name="front_logo_decoration"]');
      var backDeco = form.querySelector('[name="back_logo_decoration"]');
      var sideDeco = form.querySelector('[name="side_logo_decoration"]');

      // Primary decoration = front logo's method (used for Notion's single select)
      var primaryDecoration = frontDeco ? frontDeco.value || null : null;

      // Build design description — combine user notes + per-logo decoration details + pattern file
      var designDesc = form.querySelector('[name="design_description"]').value.trim() || '';

      var decoDetails = [];
      if (frontDeco && frontDeco.value) decoDetails.push('Front logo: ' + frontDeco.value);
      if (backDeco && backDeco.value) decoDetails.push('Back logo: ' + backDeco.value);
      if (sideDeco && sideDeco.value) decoDetails.push('Side logo: ' + sideDeco.value);
      if (decoDetails.length > 0) {
        designDesc += (designDesc ? '\n\n' : '') + 'Decoration methods — ' + decoDetails.join(', ');
      }

      if (patternFileUrl) {
        designDesc += (designDesc ? '\n\n' : '') + 'Pattern file: ' + patternFileUrl;
      }

      // Build final payload matching the webhook's expected format
      var payload = {
        fullName: form.querySelector('[name="name"]').value.trim(),
        email: form.querySelector('[name="email"]').value.trim(),
        phone: form.querySelector('[name="phone"]').value.trim() || null,
        companyTeam: form.querySelector('[name="company"]').value.trim() || null,
        hatType: hatType,
        colourSpec: colourSpec,
        panelDetails: panelDetails,
        embroideryOrPrint: primaryDecoration,
        designDescription: designDesc || null,
        frontLogoUrl: frontLogoUrl,
        backLogoUrl: backLogoUrl,
        sideLogoUrl: sideLogoUrl,
        sizes: sizes,
        purpose: form.querySelector('[name="purpose"]').value || null,
        requestedDeliveryDate: form.querySelector('[name="ideal_delivery_date"]').value || null,
        source: form.querySelector('[name="referral_source"]').value || null
      };

      return fetch(submitUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-LL-Webhook-Auth': 'hCevhVRRG852uPIi-hm7SJfQD-elWYCMF_8JNm2YYUs' },
        body: JSON.stringify(payload)
      });
    })
    .then(function (resp) {
      if (!resp.ok) {
        return resp.json().catch(function () { return {}; }).then(function (body) {
          throw new Error(body.error || 'Server responded with ' + resp.status);
        });
      }
      // Smooth transition: fade out form + intro, scroll up, show success
      var intro = document.querySelector('.cof-intro');
      form.style.transition = 'opacity 0.3s ease';
      form.style.opacity = '0';
      if (intro) {
        intro.style.transition = 'opacity 0.3s ease';
        intro.style.opacity = '0';
      }
      setTimeout(function () {
        form.style.display = 'none';
        if (intro) intro.style.display = 'none';
        successEl.style.display = '';
        // Scroll the success message into view smoothly
        var wrapper = document.querySelector('.cof-wrapper');
        if (wrapper) {
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
      localStorage.removeItem(STORAGE_KEY);
    })
    .catch(function (err) {
      errorEl.style.display = '';
      errorMsg.textContent = 'Something went wrong submitting your order. Please try again or email customs@leaguelids.com directly. (' + err.message + ')';
      submitBtn.disabled = false;
      submitText.style.display = '';
      submitLoader.style.display = 'none';
      _formSubmitting = false;
    });
  }

  /* ==========================================================================
     localStorage persistence
     ========================================================================== */

  function saveToStorage() {
    try {
      var data = {
        name: form.querySelector('[name="name"]').value,
        email: form.querySelector('[name="email"]').value,
        phone: form.querySelector('[name="phone"]').value,
        company: form.querySelector('[name="company"]').value,
        hat_type: hatTypeSelect.value,
        design_description: form.querySelector('[name="design_description"]').value,
        purpose: form.querySelector('[name="purpose"]').value,
        ideal_delivery_date: form.querySelector('[name="ideal_delivery_date"]').value,
        referral_source: form.querySelector('[name="referral_source"]').value,
        front_logo_decoration: form.querySelector('[name="front_logo_decoration"]').value,
        back_logo_decoration: form.querySelector('[name="back_logo_decoration"]').value,
        side_logo_decoration: form.querySelector('[name="side_logo_decoration"]').value,
        colour_fields: {},
        sizes: [],
        files: {}
      };

      document.querySelectorAll('[data-colour-field]').forEach(function (el) {
        if (el.value) data.colour_fields[el.name] = el.value;
      });

      sizeRowsContainer.querySelectorAll('.cof-size-row').forEach(function (row) {
        var sel = row.querySelector('[data-size-select]');
        var qty = row.querySelector('[data-qty-input]');
        if (sel && qty) {
          data.sizes.push({ size: sel.value, qty: qty.value });
        }
      });

      Object.keys(fileData).forEach(function (key) {
        if (fileData[key]) {
          data.files[key] = fileData[key].filename;
        }
      });

      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      // silently fail
    }
  }

  function restoreFromStorage() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;

      var data = JSON.parse(raw);

      setVal('[name="name"]', data.name);
      setVal('[name="email"]', data.email);
      setVal('[name="phone"]', data.phone);
      setVal('[name="company"]', data.company);

      if (data.hat_type) {
        hatTypeSelect.value = data.hat_type;
        onHatTypeChange();
      }

      if (data.colour_fields) {
        Object.keys(data.colour_fields).forEach(function (n) {
          var el = form.querySelector('[name="' + n + '"]');
          if (el) {
            el.value = data.colour_fields[n];
            // Trigger pattern toggle if needed
            if (el.hasAttribute('data-pattern-toggle')) {
              onPatternToggle(el);
            }
          }
        });
      }

      setVal('[name="design_description"]', data.design_description);
      setVal('[name="front_logo_decoration"]', data.front_logo_decoration);
      setVal('[name="back_logo_decoration"]', data.back_logo_decoration);
      setVal('[name="side_logo_decoration"]', data.side_logo_decoration);
      setVal('[name="purpose"]', data.purpose);
      setVal('[name="ideal_delivery_date"]', data.ideal_delivery_date);
      setVal('[name="referral_source"]', data.referral_source);

      // Restore size rows
      if (data.sizes && data.sizes.length > 0) {
        // First row was already created by onHatTypeChange -> rebuildSizeRows
        if (data.sizes[0]) {
          setVal('[name="size_0"]', data.sizes[0].size);
          setVal('[name="qty_0"]', data.sizes[0].qty);
        }

        for (var i = 1; i < data.sizes.length && i < MAX_SIZE_ROWS; i++) {
          addSizeRow();
          setVal('[name="size_' + i + '"]', data.sizes[i].size);
          setVal('[name="qty_' + i + '"]', data.sizes[i].qty);
        }

        updateQtyTracker();
      }

    } catch (e) {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  function setVal(selector, value) {
    if (!value) return;
    var el = form.querySelector(selector);
    if (el) el.value = value;
  }

  /* ==========================================================================
     Boot
     ========================================================================== */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
